import cx from 'classnames';
import { Switch, useRouteMatch } from 'react-router-dom';
// import { Complete } from './Funnel/Complete';
// import { OrderProcessing } from './Funnel/OrderProcessing';
// import { Pricing } from './Funnel/Pricing';
// import { SubscriptionForm } from './Funnel/SubscriptionForm';

import { NavigationSection } from '@app/context/constants';
import { sectionUrl } from '@app/context/utils';
import { useNavigation } from '@app/hooks/useNavigation';
import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { Dpo } from './Dpo/Dpo';
import { MultiTenant } from './MultiTenant/MultiTenant';
import { Overview } from './Overview';
import { Status } from './Status';
import { Summary } from './Summary/Summary';
import { DoneTasks } from './Tasks/DoneTasks';
import { TopicRoutes } from './Topic/TopicRoutes';
import { Training } from './Training/Training';
import { OpenTaskType, UserFlowItemType } from './constants';
import './route-dashboard.sass';
import { Dashboard } from './useDashboard';


function DashboardRedirect() {
  const { navigateDashboard } = useNavigation();

  useEffect(() => {
    navigateDashboard(NavigationSection.Overview);
  }, []);

  return null;
}

interface Props {
  dashboard: Dashboard;
}

export function SectionBody({ dashboard }: Props) {
  const { path } = useRouteMatch();

  const {
    navigation: { activeSection },
  } = useNavigation();

  return (
    <div className={cx('w-full', activeSection === NavigationSection.Status && 'bg-primary-200')}>
      {/* {content} */}
      <Switch>
        <Route path={`${path}${sectionUrl(NavigationSection.Overview)}`}>
          <Overview />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.DoneTasks)}`}>
          <DoneTasks />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.Status)}`}>
          <Status />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.QuestionnaireList)}`}>
          <Summary dashboard={dashboard} type={UserFlowItemType.questionnaire} />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.TaskList)}`}>
          <Summary dashboard={dashboard} type={UserFlowItemType.task} />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.DocumentList)}`}>
          <Summary dashboard={dashboard} type={UserFlowItemType.document} />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.OpenTaskList)}`}>
          <Summary dashboard={dashboard} type={OpenTaskType.openTask} />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.Training)}`}>
          <Training />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.MultiTenant)}`}>
          <MultiTenant />
        </Route>
        <Route path={`${path}/topic/:topicPath?/:subSectionPath?`}>
          <TopicRoutes dashboard={dashboard} />
        </Route>
        <Route path={`${path}${sectionUrl(NavigationSection.Dpo)}`}>
          <Dpo />
        </Route>
        <Route path={`${path}`}>
          <DashboardRedirect />
        </Route>

      </Switch>
    </div>
  );
}
